/**
 * Generic caching layer for NON-DATA use cases
 * 
 * IMPORTANT: This is NOT used for caching notes/data anymore!
 * - Data (notes, tags, etc.) is always fetched fresh from API
 * - Service Worker caches UI files (HTML/CSS/JS) for offline support
 * 
 * This module is kept for potential future use cases like:
 * - Caching user preferences (theme, settings)
 * - Caching static configuration
 * - Temporary session data
 * 
 * But NOT for API data which should always be fresh!
 */

// In-memory cache for instant access
const memoryCache = new Map()

export const cache = {
  // Get from cache
  get(key) {
    // Try memory first (instant)
    if (memoryCache.has(key)) {
      return memoryCache.get(key)
    }
    
    // Fall back to localStorage
    try {
      const stored = localStorage.getItem(`cache_${key}`)
      if (stored) {
        const data = JSON.parse(stored)
        memoryCache.set(key, data)
        return data
      }
    } catch (error) {
      console.error('Cache read error:', error)
    }
    
    return null
  },
  
  // Save to cache
  set(key, data) {
    memoryCache.set(key, data)
    try {
      localStorage.setItem(`cache_${key}`, JSON.stringify(data))
    } catch (error) {
      console.error('Cache write error:', error)
    }
  },
  
  // Clear specific cache
  clear(key) {
    memoryCache.delete(key)
    try {
      localStorage.removeItem(`cache_${key}`)
    } catch (error) {
      console.error('Cache clear error:', error)
    }
  },
  
  // Clear all cache
  clearAll() {
    memoryCache.clear()
    try {
      const keys = Object.keys(localStorage)
      keys.forEach(key => {
        if (key.startsWith('cache_')) {
          localStorage.removeItem(key)
        }
      })
    } catch (error) {
      console.error('Cache clear all error:', error)
    }
  }
}
